/**
 * Geolocation utilities for getting user's location and converting coordinates to zip codes
 */

export function getUserLocation() {
	return new Promise((resolve, reject) => {
		if (!navigator.geolocation) {
			reject(new Error('Geolocation is not supported by this browser.'));
			return;
		}

		navigator.geolocation.getCurrentPosition(
			(position) => {
				resolve({
					lat: position.coords.latitude,
					lng: position.coords.longitude
				});
			},
			(error) => {
				let errorMessage = 'Unable to retrieve your location. ';
				switch(error.code) {
					case error.PERMISSION_DENIED:
						errorMessage += 'Please allow location access to use this feature.';
						break;
					case error.POSITION_UNAVAILABLE:
						errorMessage += 'Location information is unavailable.';
						break;
					case error.TIMEOUT:
						errorMessage += 'Location request timed out.';
						break;
					default:
						errorMessage += 'An unknown error occurred.';
						break;
				}
				reject(new Error(errorMessage));
			},
			{
				enableHighAccuracy: true,
				timeout: 10000,
				maximumAge: 300000 // 5 minutes
			}
		);
	});
}

export function getZipCodeFromCoordinates(lat, lng) {
	return new Promise((resolve, reject) => {
		if (!window.google || !window.google.maps) {
			reject(new Error('Google Maps API is not loaded.'));
			return;
		}

		const geocoder = new google.maps.Geocoder();
		const latLng = new google.maps.LatLng(lat, lng);

		geocoder.geocode({ location: latLng }, (results, status) => {
			if (status !== google.maps.GeocoderStatus.OK) {
				reject(new Error('Geocoding failed: ' + status));
				return;
			}

			if (!results || results.length === 0) {
				reject(new Error('No address found for this location.'));
				return;
			}

			// Find the postal code component
			let zipCode = null;
			for (const result of results) {
				if (result.address_components) {
					for (const component of result.address_components) {
						if (component.types.includes('postal_code')) {
							zipCode = component.long_name || component.short_name;
							break;
						}
					}
					if (zipCode) break;
				}
			}

			if (!zipCode) {
				reject(new Error('Could not find a zip code for this location.'));
				return;
			}

			resolve(zipCode);
		});
	});
}
